import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUp } from "lucide-react";
import { toast } from "sonner";
import { CONTACT } from "../lib/data";
import { postNewsletter } from "../lib/api";
import Logo from "./Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await postNewsletter(email);
      toast.success("Subscribed. Welcome to the Karmaa circle.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    }
  };

  return (
    <footer className="bg-forest text-beige relative grain overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 pt-24 pb-10 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-beige/15">
          <div className="lg:col-span-5">
            <h3 className="font-serif text-4xl md:text-5xl leading-tight mb-6">
              Let’s move your <span className="italic text-gold">harvest</span> across borders.
            </h3>
            <form onSubmit={subscribe} className="flex max-w-md border-b border-beige/30 focus-within:border-gold transition-colors">
              <input
                data-testid="newsletter-input"
                value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email for trade updates"
                className="bg-transparent flex-1 py-3 text-beige placeholder:text-beige/40 outline-none text-sm"
              />
              <button data-testid="newsletter-submit" type="submit" className="text-gold text-sm uppercase tracking-widest px-3 hover:text-beige transition-colors">
                Join
              </button>
            </form>
          </div>
          <div className="lg:col-span-3">
            <p className="overline text-gold mb-5">Navigate</p>
            <ul className="space-y-3 text-sm text-beige/70">
              <li><Link to="/products" className="hover:text-gold transition-colors">All Products</Link></li>
              <li><Link to="/#about" className="hover:text-gold transition-colors">About Us</Link></li>
              <li><Link to="/gallery" className="hover:text-gold transition-colors">Gallery</Link></li>
              <li><Link to="/certifications" className="hover:text-gold transition-colors">Certifications</Link></li>
              <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="overline text-gold mb-5">Reach Us</p>
            <ul className="space-y-4 text-sm text-beige/80">
              <li className="flex gap-3"><Mail className="w-4 h-4 text-gold mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="hover:text-gold">{CONTACT.email}</a></li>
              <li className="flex gap-3"><Phone className="w-4 h-4 text-gold mt-0.5" /><a href={`tel:${CONTACT.phone}`} className="hover:text-gold">{CONTACT.phone}</a></li>
              <li className="flex gap-3"><MapPin className="w-4 h-4 text-gold mt-0.5" />{CONTACT.address}</li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-8">
          <Logo variant="white" tagline={false} />
          <p className="text-xs text-beige/50">© {new Date().getFullYear()} Karmaa Overseas. Cultivating Heritage. Exporting Excellence.</p>
          <button data-testid="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 text-xs uppercase tracking-widest text-beige/70 hover:text-gold transition-colors">
            Back to top <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
